const PENDING_UNTIL_KEY = 'app.autoreload.pendingUntil'
const LAST_AT_KEY = 'app.autoreload.lastAt'

export function getPendingAutoReloadUntil(): number | null {
  try {
    const raw = window.sessionStorage.getItem(PENDING_UNTIL_KEY)
    if (!raw) return null
    const value = Number(raw)
    return Number.isFinite(value) ? value : null
  } catch {
    return null
  }
}

export function getLastAutoReloadAt(): number | null {
  try {
    const raw = window.sessionStorage.getItem(LAST_AT_KEY)
    if (!raw) return null
    const value = Number(raw)
    return Number.isFinite(value) ? value : null
  } catch {
    return null
  }
}

export function setPendingAutoReloadUntil(untilMs: number): void {
  try {
    window.sessionStorage.setItem(PENDING_UNTIL_KEY, String(untilMs))
  } catch {
    // ignore storage failures
  }
}

export function setLastAutoReloadAt(atMs: number): void {
  try {
    window.sessionStorage.setItem(LAST_AT_KEY, String(atMs))
  } catch {
    // ignore storage failures
  }
}

export function clearPendingAutoReload(): void {
  try {
    window.sessionStorage.removeItem(PENDING_UNTIL_KEY)
  } catch {
    // ignore storage failures
  }
}
